export default "__VITE_ASSET__74301688__"